import { createRoot } from 'react-dom/client'
// One type family, as the world-class AI brands do: Geist (Vercel) carries
// every heading, number and paragraph; Geist Mono does one job, the small
// labels. Anuphan is the Thai fallback, downloaded only if Thai text appears.
// Each is a variable font with unicode-range subsets.
import '@fontsource-variable/geist'
import '@fontsource-variable/geist-mono'
import '@fontsource-variable/anuphan'
import { App } from './App.tsx'
import './index.css'

createRoot(document.getElementById("root")!).render(<App />);
